import React from "react";
import { CheckCircle } from "lucide-react";

interface NotificationToastProps {
  header: string;
  subtext: string;
  bgColor?: string;
  textColor?: string;
  iconColor?: string;
}

const NotificationToast: React.FC<NotificationToastProps> = ({
  header,
  subtext,
  bgColor,
  textColor,
  iconColor,
}) => {
  return (
    <div className="mt-4 w-full rounded-lg border border-green-500/30 dark:border-green-500/20 bg-green-50 dark:bg-green-900/10 p-4 flex items-start gap-3 transition-all duration-200">
      <div className="flex-shrink-0 mt-0.5">
        <CheckCircle className="w-5 h-5 text-green-600 dark:text-green-400" />
      </div>
      <div className="flex-1 min-w-0">
        <h3 className="text-sm font-semibold text-black dark:text-text-primaryDark mb-1">
          {header}
        </h3>
        <p className="text-xs text-black/70 dark:text-text-secondaryDark leading-relaxed">
          {subtext}
        </p>
      </div>
    </div>
  );
};

export default NotificationToast;
